<template>

  <svg
    t="1631089004895"
    class="icon"
    viewBox="0 0 1061 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5082"
    width="64"
    height="64"
  ><path d="M128.6666668 128.6666668v766.6666664h799.9999998V128.6666668H128.6666668zM62 62h933.33333339v900H62V62z" p-id="5083" /><path d="M287 574.4999999c-32.19999961 0-58.333333-25.2-58.333333-56.2666667C228.66666699 487.1999999 254.80000039 461.9999999 287 461.9999999s58.333333 25.2 58.333333 56.2666667c0 31.0333333-26.1333334 56.2333333-58.333333 56.2333333z m233.33333291 0c-32.19999961 0-58.333333-25.2-58.33333301-56.2666667 0-31.0333333 26.1333334-56.2333333 58.33333301-56.2333333s58.333333 25.2 58.33333389 56.26666671c0 31.0333333-26.1333334 56.2333333-58.33333389 56.23333329z m233.33333379 0c-32.19999961 0-58.333333-25.2-58.33333301-56.2666667 0-31.0333333 26.1333334-56.2333333 58.33333301-56.2333333s58.333333 25.2 58.33333301 56.26666671c0 31.0333333-26.1333334 56.2333333-58.33333301 56.23333329z" p-id="5084" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconOther',
} as DefineComponent
</script>